export default "__VITE_ASSET__BopGjG1r__"